<template>
  <span class="tp-spinner" :style="{ width: size + 'px', height: size + 'px' }" role="status" aria-label="Loading">
    <span class="tp-spinner__ring"></span>
  </span>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Spinner',
  props: {
    size: { type: Number, default: 18 },
  },
});
</script>

<style scoped>
.tp-spinner {
  display: inline-block;
  position: relative;
}

.tp-spinner__ring {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 999px;
  border: 2px solid var(--tm-border-strong, rgba(125, 161, 191, 0.25));
  border-top-color: var(--tm-accent, var(--blue));
  animation: tp-spin 0.7s linear infinite;
}

@keyframes tp-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
